import { render } from "./DeleteConfirmationPopup.vue?vue&type=template&id=1233f898&scoped=true"
import script from "./DeleteConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationPopup.vue?vue&type=script&lang=js"

import "./DeleteConfirmationPopup.vue?vue&type=style&index=0&id=1233f898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1233f898"]])

export default __exports__